import { Controller } from "@hotwired/stimulus"
import Flatpickr from "stimulus-flatpickr"
import weekSelectPlugin from "flatpickr/dist/plugins/weekSelect/weekSelect"

export default class extends Flatpickr {
  static targets = ["hiddenInput"]

  initialize() {
    this.config = {
      inline: true,
      plugins: [weekSelectPlugin({})],
      onChange: this.onChange.bind(this),
      onMonthChange: this.onMonthChange.bind(this)
    }
  }

  connect() {
    super.connect()
  }

  onChange(selectedDates, dateStr, instance) {
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = dateStr
      this.element.requestSubmit()
    }
  }

  onMonthChange(selectedDates, dateStr, instance) {
    let dateToSelect = new Date(instance.currentYear, instance.currentMonth, 1)

    const minDate = instance.config.minDate
    const maxDate = instance.config.maxDate

    if (minDate && dateToSelect < minDate) {
      dateToSelect = minDate
    }

    if (maxDate && dateToSelect > maxDate) {
      dateToSelect = maxDate
    }

    instance.setDate(dateToSelect, true)
  }

  disconnect() {
    super.disconnect()
  }
}
